<div [class]="visible ? 'flex flex-col h-full' : 'hidden'">
  <div class="qb-content-card flex flex-row gap-4 qb-responsive-split"
    [style.flex-grow]="program.programTypeId === ProgramTypeEnum.Inventory ? 0 : null">
    <div class="qb-detail-card h-fit w-1/2">
      <div class="flex flex-col gap-3">
        <div class="flex flex-row">
          <div class="w-full">
            <prox-field label="Name">
              <input type="text" [disabled]="parent.isReadOnly()" pInputText [pAutoFocus]="true"
                [(ngModel)]="program.name" [bzModel]="program" name="name">
            </prox-field>
          </div>
        </div>
        <div class="flex flex-col">
          <div class="w-full mt-3">
            <prox-field label="Description">
              <textarea [disabled]="parent.isReadOnly()" rows="3" cols="30" pTextarea [(ngModel)]="program.description"
                [bzModel]="program" [attr.placeholder]="descriptionPlaceholder" name="description"></textarea>
            </prox-field>
          </div>
          <div class="flex flex-row gap-3">
            <div *ngIf="parent.isManaged()" class="w-1/3 mt-4">
              <prox-field label="Shipping Frequency">
                <p-select [disabled]="parent.isReadOnly()" [options]="shipFrequencies" optionLabel="name"
                  optionValue="id" [(ngModel)]="program.shipFrequencyId" [bzModel]="program" name="shipFrequencyId"
                  class="w-full"></p-select>
              </prox-field>
            </div>
            <div class="w-1/2 mt-4">
              <prox-field label="Proximity Organization">
                <p-select [disabled]="parent.isReadOnly()" [options]="approvalTreeOptions" optionLabel="name"
                  optionValue="id" optionDisabled="disabled" [(ngModel)]="currentApprovalTreeId"
                  (onChange)="onApprovalTreeChanged($event.value)" [bzModel]="program" name="approvalTreeId"
                  class="w-full"></p-select>
              </prox-field>
            </div>
            <div class="mt-11">
              <p-button styleClass="p-button p-button-sm" [disabled]="parent.hasChanges()"
                (onClick)="parent.onGotoApprovalTree(this.program.approvalTree)" title="View">View</p-button>
            </div>
          </div>
          <div class="flex flex-row">
            <div class="flex flex-col mt-4">
              <prox-field label="Purchase Order Type">
                <div class="flex mt-2 gap-x-4">
                  <div *ngFor="let poType of programPurchaseOrderTypes" class="field-checkbox">
                    <p-radioButton [id]="'programPurchaseOrderType-' + poType.name" name="programPurchaseOrderType"
                      [value]="poType.id" [disabled]="parent.isReadOnly()" [bzModel]="program"
                      [(ngModel)]="program.programPurchaseOrderTypeId" (onClick)="onPoChanged($event, poType.id)" />
                    <label [for]="poType.name" class="ml-2">
                      {{ poType.description }}
                    </label>
                  </div>
                </div>
              </prox-field>
            </div>
          </div>
          <div>
            <div class="mt-4 w-1/3" *ngIf="program.programPurchaseOrderTypeId === 2">
              <prox-field label="Program Purchase Order">
                <p-select [disabled]="parent.isReadOnly()" [options]="accountPos" optionLabel="purchaseOrder"
                  optionValue="id" [(ngModel)]="program.accountPurchaseOrderId" [bzModel]="program"
                  name="accountPurchaseOrderId" [showClear]="true" placeholder="Select a purchase order"
                  class="w-full"></p-select>
              </prox-field>
            </div>
          </div>
          <div class="mt-2" *ngIf="poMessage">
            <div class="text-red-500">{{ poMessage }}</div>
          </div>
          <div class="mt-4 w-1/2">
            <p-checkbox [disabled]="parent.isReadOnly()" [(ngModel)]="program.isPurchaseOrderRequired" [binary]="true"
              [bzModel]="program" name="isPurchaseOrderRequired" inputId="isPurchaseOrderRequired"></p-checkbox>
            <label for="isPurchaseOrderRequired" class="ml-2">A purchase order is required for every order</label>
          </div>
          <div class="flex flex-row">
            <div class="flex flex-col mt-4">
              <prox-field label="Procurement Card (p-card) Type">
                <div class="flex mt-2 gap-x-4">
                  <div *ngFor="let pcType of programPcardTypes" class="field-checkbox">
                    <p-radioButton [id]="'programPcardType-' + pcType.name" name="programPcardType" [value]="pcType.id"
                      [disabled]="parent.isReadOnly()" [bzModel]="program" [(ngModel)]="program.programPcardTypeId"
                      (onClick)="onPcardChanged($event, pcType.id)" />
                    <label [for]="pcType.name" class="ml-2">
                      {{ pcType.description }}
                    </label>
                  </div>
                </div>
              </prox-field>
            </div>
          </div>
          <div>
            <div class="mt-4 w-1/3" *ngIf="program.programPcardTypeId === 2">
              <prox-field label="Program Procurement Card">
                <p-select [disabled]="parent.isReadOnly()" [options]="pcards" optionLabel="namedesc" optionValue="id"
                  [(ngModel)]="program.accountProcurementCardId" [bzModel]="program" name="accountProcurementCard"
                  class="w-full"></p-select>
              </prox-field>
            </div>
          </div>
          <div class="mt-2" *ngIf="pcardMessage">
            <div class="text-red-500">{{ pcardMessage }}</div>
          </div>
          <div class="mt-4 w-1/2">
            <p-checkbox [disabled]="parent.isReadOnly()" [(ngModel)]="program.isPcardRequired" [binary]="true"
              [bzModel]="program" name="isPcardRequired" inputId="isPcardRequired"></p-checkbox>
            <label for="isPcardRequired" class="ml-2">A procurement card (p-card) is required for every order</label>
          </div>
          <div class="flex flex-col gap-3 mt-3">
            <div class="w-1/2">
              <p-checkbox [disabled]="parent.isReadOnly()" [(ngModel)]="program.doAllOrdersRequireApproval"
                [binary]="true" [bzModel]="program" name="doAllOrdersRequireApproval"
                inputId="doAllOrdersRequireApproval"></p-checkbox>
              <label for="doAllOrdersRequireApproval" class="ml-2">Every order requires approval</label>
            </div>
            <div *ngIf="parent.isManaged()" class="w-1/2">
              <p-checkbox [disabled]="parent.isReadOnly()" [(ngModel)]="program.canShipHome" [binary]="true"
                [bzModel]="program" name="canShipHome" inputId="canShipHome"></p-checkbox>
              <label for="canShipHome" class="ml-2">Orders may ship to Account User home address</label>
            </div>
          </div>

          <div *ngIf="parent.isManaged()" class="qb-detail-card qb-primary-tint mt-5">
            <div class="qb-group-label">Collect, Organize and Place</div>
            <p class="text-sm mb-3">
              Converts this program to a collection campaign. Approved orders are held for your review instead of going
              straight to the supplier, so you can chase missing orders and correct purchase orders, groups and shipping
              addresses before anything ships. Releasing the batch places every collected order and returns the program
              to normal handling.
            </p>

            <div>
              <p-checkbox [disabled]="parent.isReadOnly()" [(ngModel)]="program.collectAndPlace" [binary]="true"
                [bzModel]="program" name="collectAndPlace" inputId="collectAndPlace"
                (onChange)="onCollectAndPlaceChanged()"></p-checkbox>
              <label for="collectAndPlace" class="ml-2">Collect orders for review before placing with suppliers</label>
            </div>

            <div *ngIf="program.collectAndPlace" class="flex flex-row gap-3 mt-4">
              <div class="w-1/2">
                <prox-field label="Collection Scope">
                  <p-select [disabled]="parent.isReadOnly()" [options]="collectionScopes" optionLabel="name"
                    optionValue="id" [(ngModel)]="program.collectionScopeId" [bzModel]="program"
                    name="collectionScopeId" (onChange)="onCollectionScopeChanged()" class="w-full"></p-select>
                </prox-field>
              </div>
              <div class="w-1/2" *ngIf="program.collectionScopeId === CollectionScopeEnum.ProgramWide">
                <prox-field label="Earliest Placement Date">
                  <p-datepicker [disabled]="parent.isReadOnly()" [(ngModel)]="program.earliestPlacementDate"
                    [bzModel]="program" name="earliestPlacementDate" styleClass="w-full"></p-datepicker>
                </prox-field>
              </div>
            </div>

            <!-- The boundary for one-order-per-collection: each Account User may place one order
                 dated on or after this. Defaulted to today when collection is switched on, and
                 editable because an administrator setting up on Tuesday for a collection that
                 opened Monday must be able to say so. Shared across the whole program - every
                 group collects from the same moment, while each still releases on its own
                 schedule. See Docs/Collect-Organize-Place.md 4b. -->
            <div *ngIf="program.collectAndPlace" class="flex flex-row gap-3 mt-4">
              <div class="w-1/2">
                <prox-field label="Collection Start Date">
                  <p-datepicker [disabled]="parent.isReadOnly()" [(ngModel)]="program.collectionStartDate"
                    [bzModel]="program" name="collectionStartDate" styleClass="w-full"></p-datepicker>
                </prox-field>
              </div>
              <div class="w-1/2 flex items-end">
                <div class="text-sm pb-2">
                  One order per person from this date. Orders placed before it are not counted.
                </div>
              </div>
            </div>

            <div *ngIf="program.collectAndPlace" class="mt-2 text-sm">
              {{ collectionScopeHint }}
            </div>

            <div *ngIf="collectionReleasedMessage" class="mt-2">
              <div class="text-red-500">{{ collectionReleasedMessage }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="qb-info-cards flex flex-col gap-4">
      <p-card header="Current Status" class="status-card">
        <h3 id="programStatus">{{statusName()}}</h3>
      </p-card>
      <p-card header="Program Type" class="status-card">
        <h3>{{program.programTypeLongName}}</h3>
      </p-card>
      <p-card *ngIf="program.collectAndPlace" header="Order Flow" class="status-card">
        <h3>Collect, Organize and Place</h3>
        <div class="text-sm">{{ collectionScopeBadge }}</div>
      </p-card>
      <p-card *ngIf="showAccessibilityInfo()" header="Program Accessibility" class="status-card">
        <h4>{{program.programStartDateType?.name}}</h4>
        <div class='grid grid-cols-3 gap-2'
          *ngIf="program.programStartDateTypeId === ProgramStartDateTypeEnum.FixedStartAndEndDate">
          <div *ngIf="parent.isManaged()" class="col-span-2">Available # of days after
            join date: </div>
          <div *ngIf="parent.isManaged()" class="font-bold">{{program.availableAfterJoinDateDays}}</div>
          <div class="col-span-2">Start date: </div>
          <div class="font-bold">{{program.startDate | date}}</div>
          <div class="col-span-2">End date: </div>
          <div class="font-bold">{{program.endDate | date}}</div>
        </div>

        <div class='grid grid-cols-3 gap-2'
          *ngIf="program.programStartDateTypeId === ProgramStartDateTypeEnum.VariableStartAndEndDate">
          <div class="col-span-2">Available # of days after join date: </div>
          <div class="font-bold">{{program.availableAfterJoinDateDays}}</div>
          <div class="col-span-2">Duration (days): </div>
          <div class="font-bold">{{program.durationDays}}</div>
        </div>

        <div class='grid grid-cols-3 gap-2'
          *ngIf="program.programStartDateTypeId === ProgramStartDateTypeEnum.VariableStartFixedEndDate">
          <div class="col-span-2">Available # of days after join date: </div>
          <div class="font-bold">{{program.availableAfterJoinDateDays}}</div>
          <div class="col-span-2">End date: </div>
          <div class="font-bold">{{program.endDate | date}}</div>
        </div>

      </p-card>
      <p-button (click)="onCycle()" styleClass="w-full" label="Cycle this Program" [hidden]="!allowCycle()"
        icon="fa-sharp-duotone fa-solid fa-arrows-spin"></p-button>
      <div *ngIf="helpfulHints.length > 0" class="mt-4 max-w-sm rounded-md px-4 py-3"
        style="background: var(--p-surface-0); border-left: 3px solid var(--p-amber-500); box-shadow: 0 1px 3px rgba(0,0,0,0.08);">
        <div class="flex items-center gap-2 mb-2">
          <i class="fa-duotone fa-lightbulb text-lg" style="color: var(--p-amber-500);"></i>
          <span class="font-semibold text-base">Helpful Hints</span>
        </div>
        <ul class="list-disc pl-5 text-base flex flex-col gap-1">
          <li *ngFor="let hint of helpfulHints">{{ hint }}</li>
        </ul>
      </div>
    </div>
  </div>
  <div *ngIf="program.programTypeId === ProgramTypeEnum.Inventory"
    class="qb-content-card mt-2 mb-1 flex flex-col grow min-h-0">
    <div class="qb-group-label">Managed Distribution Programs That May Draw From This Inventory</div>
    <p class="text-sm mb-2">
      Use <strong>Apply</strong> to make a Managed Distribution program draw from this Inventory Program, or
      <strong>Clear</strong> to stop it from drawing from any Inventory Program. Only Managed Distribution
      programs whose supplier account permits inventory are shown. Changes take effect on <strong>Save</strong>.
    </p>
    <div class="grow min-h-0 h-full">
      <prox-ag-grid gridId="mdSuppliersForInventoryGrid" [gridOptions]="mdSuppliersGridOptions"
        [rowData]="mdSuppliers"></prox-ag-grid>
    </div>
  </div>
  <div>
    <p-dialog closable="false" [(visible)]="displayDialog" header="Program Cycle" [modal]="true"
      [style]="{width: '30vw'}">
      <ng-template pTemplate="content">
        <h6>Program is cycled and ready for edit and save. PLEASE NOTE:</h6>
        <span class="text-lg mt-1 mb-1 font-bold">The following Cycled Program properties
          have been set to default:</span>
        <div class="mt-1">
          <ul>
            <li>1. Purchase Order Type</li>
            <li>2. Purchase Order Required?</li>
            <li>3. Purchase Card Type</li>
            <li>4. Purchase Card Required?</li>
            <li>5. Collect, Organize and Place &mdash; turned off on both this Program and the one it replaces</li>
            <li>6. Collection Scope, Earliest Placement Date and release history</li>
          </ul>
        </div>
        <p class="mt-3" *ngIf="!parent.cycleDeferredTreeName">
          The Organization Tree carries forward to the new cycle. Its Program User Group settings do not
          &mdash; purchase orders, purchase cards and ordering time frames must be entered anew.
        </p>
        <p class="mt-3 font-bold" *ngIf="parent.cycleDeferredTreeName">
          The Organization Tree '{{ parent.cycleDeferredTreeName }}' carries forward to the new cycle, but its
          Program User Group settings could NOT be cleared &mdash; the outgoing Program is still accepting
          orders through them. What you see there is still the outgoing Program's. Retire it, then replace
          the purchase orders, purchase cards and ordering time frames before activating this cycle.
        </p>

      </ng-template>
      <ng-template pTemplate="footer">
        <p-button (onClick)="hideDialog()" label="Close" icon="pi pi-times" size="small"></p-button>
      </ng-template>
    </p-dialog>
  </div>
</div>